import {LocalStorage} from '@/util/local-storage';

let newDateUtil__overrideTime: Date | undefined;
const persisted_newDateUtil__overrideTime = LocalStorage.get('newDateUtil__overrideTime', null);
if (persisted_newDateUtil__overrideTime) {
    newDateUtil__overrideTime = new Date(persisted_newDateUtil__overrideTime);
}

export const NewDateUtil = () => {
    if (newDateUtil__overrideTime) {
        return new Date(newDateUtil__overrideTime.getTime());
    }
    return new Date();
};

NewDateUtil.overrideTime = function(date?: Date) {
    newDateUtil__overrideTime = date;
    LocalStorage.set('newDateUtil__overrideTime', date ? date.toISOString() : null);
};

NewDateUtil.isOverriden = () => !!newDateUtil__overrideTime;
